import jwtDecode from 'jwt-decode';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { JwtDecodedUser } from '../models/UserModels';
import { userSelector } from '../store/shared/userSlice';

export default function useUser(): JwtDecodedUser | null {
  const { value: user } = useSelector(userSelector);
  const accessToken: string = user?.access_token;

  return useMemo<JwtDecodedUser | null>(() => {
    if (!accessToken) return null;
    try {
      return jwtDecode<JwtDecodedUser>(accessToken);
    } catch {
      return null;
    }
  }, [accessToken]);
}
